
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';

import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
import { renderTextArea, renderTextField } from '../../../../components/reduxFields';
import { SaveBulkNoteAction } from './actions/ManageClaimActions';
import SmallLoader from './../../../../img/small-loader.gif';

const validate = (values) => {
    const errors = {};

    if (!values.title) {
        errors.title = 'Please enter note title'
    }
    if (!values.notes) {
        errors.notes = 'Please enter notes'
    }
    return errors;
};


class AddNoteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            claimId: props.claimId ? props.claimId : null,
            noteId: null,
        }
    }

    handleClose = () => {
        this.props.closeDialog();
    }

    onSubmitHandler(formProps) {
    let postData = {
        "claimIds": this.props.claimIds.join(','),
        "title": formProps.title,
        "notes": formProps.notes,
        }
     this.props.SaveBulkNoteAction(postData);
     this.props.closeDialog();
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;
      
        return (
            <div>
                <Dialog
                    className="custom_modal"
                    title='Claim Internal Notes'
                    modal={false}
                    open={true}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form" >
                                <div className="row">
                                    <div className="col-sm-12 require mt-30">
                                        <Field
                                            name="title"
                                            label="Title"
                                            type="text"
                                            maxLength="100"
                                            component={renderTextField} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 require mt-30">
                                        <Field
                                            name="notes"
                                            label="Note"
                                            type="text"
                                            maxLength="4000"
                                            component={renderTextArea} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 pt20 btn_rt">
                                        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
                                        <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Save" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    };
};

AddNoteModal = reduxForm({
    form: 'AddNoteModalForm', // a unique identifier for this form
    validate,
})(AddNoteModal);

export default connect(mapStateToProps, { SaveBulkNoteAction })(AddNoteModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/AddNoteModal.js